let overlayStack: Array<string> = [];

export const addToOverlayStack = (id: string): void => {
  overlayStack.push(id);
};

export const removeFromOverlayStack = (id: string): void => {
  overlayStack = overlayStack.filter((stackId) => stackId !== id);
};

export const isTopmostOverlay = (id: string): boolean => {
  return overlayStack.length > 0 && overlayStack[overlayStack.length - 1] === id;
};

export const hasActiveOverlays = (): boolean => {
  return overlayStack.length > 0;
};
